// extracted by mini-css-extract-plugin
export var accordion = "elements-module--accordion--ojYud";
export var accordionItem = "elements-module--accordionItem--lWfW9";
export var b2bList = "elements-module--b2b-list--g4bTy";
export var collapse = "elements-module--collapse--uVkZr";